import { h } from 'preact';
import SearchIcon from 'utils/icon/icon-search.svg';
import HeartIcon from 'utils/icon/icon-heart.svg';
import CartIcon from 'utils/icon/icon-cart.svg';
import { useEffect, useState } from 'preact/hooks';
import clsx from 'clsx';

const HeaderButton = ({ type, cartQty, settings }) => {
  if (type === 'Wishlist') {
    const [count, setCount] = useState(0);
    const url = settings?.link ? settings.link : '#swym-wishlist';

    useEffect(() => {
      const eventHandle = (e) => {
        setCount((i) => (e.type === 'swym_added' ? i + 1 : i - 1));
      };
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push(() => {
        window._swat.fetchWrtEventTypeET(async (items) => {
          setCount(items.length);
        }, window._swat.EventTypes.addToWishlist);
      });
      document.addEventListener('swym_removed', eventHandle);
      document.addEventListener('swym_added', eventHandle);
      return () => {
        document.removeEventListener('swym_removed', eventHandle);
        document.removeEventListener('swym_added', eventHandle);
      };
    }, []);

    useEffect(() => {
      window.swymCount = count;
    }, [count]);

    return (
      <a className="swym-wishlist hidden tablet:block" href={url}>
        <HeartIcon
          className={clsx('w-20  ml:w-28 h-auto', {
            'fill-current': count > 0,
          })}
        />
      </a>
    );
  }
  if (type === 'Search') {
    return (
      <button
        id="desktop-search-overlay-toggle"
        className="hidden tablet:block"
      >
        <SearchIcon className="w-24 ml:w-28 h-auto" />
      </button>
    );
  }
  if (type === 'Cart') {
    return (
      <button
        type="button"
        className="relative"
        onClick={() => document.dispatchEvent(new CustomEvent('openMiniCart'))}
      >
        <CartIcon className="w-24 ml:w-28 ml:md:w-36 md:w-36 tablet:w-24 ml:tablet:w-28 h-auto" />
        {cartQty !== false && (
          <span className="cart-counter absolute w-14 h-14 body-6 flex items-center justify-center  overflow-hidden text-white bg-black rounded-full bottom-0 -right-3">
            {cartQty}
          </span>
        )}
      </button>
    );
  }
  return null;
};

const HeaderButtons = ({ buttons }) => {
  const [cartQty, setCartQty] = useState(false);
  const listenerHandle = (e) => {
    setCartQty(e.detail > 99 ? 99 : e.detail);
  };

  useEffect(() => {
    document.addEventListener('updateCartCount', listenerHandle);

    return () => {
      document.removeEventListener('updateCartCount', listenerHandle);
    };
  }, []);

  return (
    <div className="flex gap-24 items-center">
      {buttons.map((button) => (
        <HeaderButton {...button} cartQty={cartQty} key={button.type} />
      ))}
    </div>
  );
};

export default HeaderButtons;
